export default __webpack_public_path__ + "static/media/sfondohome.4344d146.png";